import $ from 'jquery';
import Mustache from 'mustache';

const contactUs = {
  init() {
    const localStorageKey = 'nhtContactUs';
    const template = $('#template-contact-us').html();
    if (!template) {
      return;
    }

    // Fetch contact us data from storage
    let data = (function() {
      try {
        return JSON.parse(window.localStorage.getItem(localStorageKey));
      }
      catch {
        return null;
      }
    }());

    // Create and store contact us data object
    if (!data) {
      data = {
        seen: false,
      };

      window.localStorage.setItem(localStorageKey, JSON.stringify(data));
    }

    // Contact us element has already been shown to user
    if (data.seen) {
      return;
    }

    // Append rendered contact us element to dom
    $('body').append(Mustache.render(template));

    const notificationClosed = function() {
      data.seen = Date.now();
      window.localStorage.setItem(localStorageKey, JSON.stringify(data));
    };

    // Show contact us element after delay
    const delay = 10000;
    const $container = $('[data-contact-us="notification"]');
    setTimeout(() => {
      $container.slideDown(300);
      $container.find('[data-contact-us-close]').on('click', function() {
        $container.slideUp(300, function() {
          $container.remove();
        });
        notificationClosed();
        return false;
      });
    }, delay);

    $(document).on('click', '[data-contact-us-cta]', notificationClosed);
  }
};

export default contactUs;
